/* eslint-disable prefer-promise-reject-errors */

import { Notifications } from "d-react-components";
import { isEmpty } from "lodash";
// import PermissionUtils from "../utils/PermissionUtils";

const UNAUTHORIZE = 401;
const SERVER_ERROR = 502;
const DATA_ERROR = 400;

export const AccessTokenInterceptor = {
  addAccessToken: (config: any) => {
    const headers = { ...config.headers, Accept: "application/json" };
    const authToken = config?.data?.username + ":" + config?.data?.password;
    headers["Authorization"] = "Basic " + btoa(authToken);
    config.headers = headers;
    return config;
  },

  onRejected: (error: any) => {
    return Promise.reject(error);
  },
};

export const AddTokenToURL = {
  addAccessToken: (config: any) => {
    // const token = getAdminToken();
    // if (!isEmpty(token)) {
    //     const addedParamUrl = addUrlParam(config?.url, "api_token", token);
    //     config.url = addedParamUrl;
    // }

    return config;
  },
  onRejected: (error: any) => {
    return Promise.reject(error);
  },
};
